module.exports = __webpack_public_path__ + "img/avatar-placeholder.f7f63b88.png";